import axios from 'axios';

import CTO from './cto';
import { contextParameterInterceptor } from '../util';

// ISNODE is boolean false in production frontend, which makes all URLs relative; boolean true during SSR;
// when it's true, all API URLs get prefixed with production domain to make sure HPServices data is retrievable;
// thanks to endsWith(..., "hp.com") checks, URLs stay prefixed even on local environments when ISNODE might be
// accidentally missing and document.location.hostname resolves to "localhost"
const isNode = process.env.ISNODE;
const basename = process.env.BASENAME;

const getBaseUrl = () => {
    let currHost = isNode ? 'server' : document.location.hostname;
    if (currHost.endsWith('hp.com')) {
        //attempt to identify lower environment subdomain
        const [subdomain] = currHost.split('.');
        const envPrefix = ['store', 'www'].includes(subdomain) ? '' : `${subdomain}.`;
        return `https://${envPrefix}cto.store.hp.com/SterlingConfigRESTfulWebSvcApp/rest/configs/json/`;
    } else {
        //attempt to identify lower environment subdomain
        try {
            const [subdomain] = process.env.DOMAIN.split('.');
            const envPrefix = ['store', 'www'].includes(subdomain) ? '' : `${subdomain}.`;
            return `https://${envPrefix}cto.store.hp.com/SterlingConfigRESTfulWebSvcApp/rest/configs/json/`;
        } catch (e) {}
    }
};

export const SterlingAPI = function (baseUrl) {
    let self = this;
    let config = {
        siteInfo: {
            langId: -1,
            storeId: 10151,
            catalogId: 10051,
        },
    };
    let sterlingInstance = axios.create({
        baseURL: baseUrl || getBaseUrl(),
        //set a longer timeout for browser side call
        timeout: isNode ? 3000 : 60000 * 2,
    });
    sterlingInstance.interceptors.request.use(contextParameterInterceptor);

    self.cto = new CTO(config, sterlingInstance);
};

const _SterlingAPI = new SterlingAPI();

export default _SterlingAPI;
